async function loadBanners(category) {
  let banners = [];
  category.find('.banner').each(async function (index, banner) {
    banners.push(banner);
  });

  for (let index = 0; index < banners.length; index++) {
    const banner = banners[index];

    if ($(banner).hasClass('is-loaded') || !$(banner).data('file-id')) return;

    const response = await fetch('/wp-admin/admin-ajax.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: `action=load_banner&post_id=${$(banner).data('post-id')}&file_id=${$(banner).data('file-id')}`,
    });

    const url = await response.text();

    $(banner).addClass('is-loaded').html('<iframe src="' + url + '" frameborder="0" allowfullscreen></iframe>');
  }
}

export function ComponentBanners() {
  if ($('body').hasClass('page-template-banners')) {
    $('.btn-navigation').on('click', function (event) {
      event.preventDefault();

      const target = $(this).attr('href');

      $('.btn-navigation').addClass('btn-outline-primary').removeClass('btn-primary');
      $(this).removeClass('btn-outline-primary').addClass('btn-primary');

      $('.banners-category').removeClass('d-flex').addClass('d-none');
      $(target).removeClass('d-none').addClass('d-flex');
    });

    loadBanners($('.banners-category').first());
  }

  $('.btn-replay').on('click', function (event) {
    event.preventDefault();

    const banner = $(this).parent().prev();
    const html = banner.html();

    banner.removeClass('is-loaded').html('<div class="d-flex justify-content-center align-items-center h-100"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>');

    setTimeout(function () {
      banner.addClass('is-loaded').html(html);

    }, 250);
  });
}
